import React from 'react';
import { Box, TextField, Button, Paper } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const QueryInput = ({ query, onQueryChange, onQuerySubmit, loading }) => {
  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && event.shiftKey === false) {
      event.preventDefault();
      onQuerySubmit();
    }
  };

  return (
    <Paper 
      elevation={2} 
      sx={{ 
        p: 3, 
        mt: 4, 
        borderRadius: 2,
        backgroundColor: 'white'
      }}
    >
      <Box component="form" noValidate autoComplete="off">
        <TextField
          fullWidth
          label="Enter your question"
          multiline
          rows={3}
          value={query}
          onChange={onQueryChange}
          onKeyPress={handleKeyPress}
          variant="outlined"
          placeholder="e.g., What is the fill rate for Surest on latest file processed?"
          disabled={loading}
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<SendIcon />}
            onClick={onQuerySubmit}
            disabled={loading || !query.trim()}
            sx={{ px: 4, py: 1 }}
          >
            Generate Response
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default QueryInput;
